import { QueryKey, UseQueryOptions, useQuery } from 'react-query';

import { getSamples } from 'services/people';

export default function usePeopleSamples(
  uuids: string[],
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    [`people-samples`, uuids],
    () => {
      return getSamples(uuids).then((response) => {
        if (!response.ok) {
          throw new Error(response?.originalError?.message || '');
        }
        return response.data;
      });
    },
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
